import { MonedaService } from '@services/moneda-service';
import {Component, OnInit, ViewChild} from '@angular/core';
import { Location } from '@angular/common';
import { DialogsService } from '@services/dialogs-service';
import { NavigationService } from '@services/navigation-service';
import { Router } from '@angular/router';
import {PATH_PIZARRA, PATH_PRECIOS, PATH_VALIDATE_PIZARRA} from '../../../navigation/navigation.module';
import * as moment from 'moment';
import { PreciosService } from '@services/precios-service';
import { PricePipe } from '@utils/pipes/price';
import { SpinnerService } from '@services/spinner-service';
import { MdSnackBar } from '@angular/material';
import { parseDate, dateToUnixTime, DateTimePipe } from '@utils/index';
import { PermisosService } from '@services/permisos-service';
import {PageHeaderComponent} from '@common/page-header';
import {ResponsiveService} from '@services/responsive.service';
import {Breakpoints, BreakpointsObserverService} from '@services/breakpoints-observer.service';

@Component({
  selector: 'app-validate-precio',
  templateUrl: './validate-precio.component.html',
  styleUrls: ['./validate-precio.component.scss']
})
export class ValidatePrecioComponent implements OnInit {

  @ViewChild(PageHeaderComponent) pageHeader: PageHeaderComponent;
  web = true;

  backDefault = '/' + PATH_PRECIOS;

  constructor(private dialogsService: DialogsService,
              private navService: NavigationService,
              private location: Location,
              private router: Router,
              private preciosService: PreciosService,
              private monedaService: MonedaService,
              private pricePipe: PricePipe,
              private spinnerService: SpinnerService,
              private snackBar: MdSnackBar,
              private dateTimePipe: DateTimePipe,
              private permisosService: PermisosService,
              private breakpointsService: BreakpointsObserverService,
              private responsiveService: ResponsiveService,
  ) {
    this.permisosService.verificarAccesoDeURL();
    this.monedaService.Options.subscribe(newValue => {
      this.monedaOptions = newValue;
    });
    breakpointsService.observe([Breakpoints.Web]).subscribe(x => {
      this.web = x.matches && responsiveService._isDesktop;
    });
  }

  columns = ['accion', 'mercado', 'fecha', 'producto', 'negocio', 'entrega', 'moneda', 'precio', 'varianza', 'responsable'];

  pizarraColumns = ['accion', 'mercado', 'fecha de cotización', 'fecha de creación', 'producto', 'moneda', 'precio', 'responsable'];

  preciosOriginal = [];
  precios = [];

  private editFechaIndex = 0;

  isPizarraValidation = false;

  monedaOptions = [];

  private maxDate = new Date(Number(moment().format('YYYY')), Number(moment().format('MM')) - 1, Number(moment().format('DD')));

  @ViewChild('datePicker') datePicker;

  ngOnInit() {
    this.isPizarraValidation = this.router.url === `/${PATH_VALIDATE_PIZARRA}`;
    if (this.isPizarraValidation) {
      this.columns = this.pizarraColumns;
      this.backDefault = '/pizarra';
    }
    this.getPrecios();
  }

  getPrecios() {
    if (!this.isPizarraValidation) {
      this.preciosService.getPreciosToValidate()
        .subscribe(res => {
          if (res) {
            this.preciosOriginal = res.ResponseData;
            this.formatData(this.preciosOriginal);
          }
        });
    } else {
      this.preciosService.getPreciosToValidatePizarra()
        .subscribe(res => {
          if (res) {
            this.preciosOriginal = res;
            this.formatData(this.preciosOriginal);
          }
        });
    }

  }

  formatData(data) {
    data.forEach(prec => {
      if (!this.isPizarraValidation)  {
        this.precios.push({
          id: prec.Id,
          fecha: prec.Fecha,
          negocio: prec.Entrega.Id === 3 ? 'Forward' : prec.Entrega.Id === 4 ? 'Pago Diferido' : 'Disponible',
          entrega: prec.Posicion === null ? prec.Entrega.Entrega : prec.Posicion.Posicion.charAt(0).toUpperCase() + prec.Posicion.Posicion.slice(1),
          moneda: prec.Moneda.Simbolo,
          producto: prec.Producto.Producto,
          precio: prec.Precio,
          varianza: prec.Varianza,
          responsable: prec.Usuario.UserFullName,
          checked: false,
          // precio anterior cargado en esta posicion y producto, se usa para calcular la varianza en caso de cambio
          precioAnterior: parseFloat(prec.Precio) - (parseFloat(prec.Varianza)),
          // precio original cargado antes de ser este editado, se usa para verificar si hubo ediciones de precio
          precioOriginal: prec.Precio,
          posicionId: prec.Posicion === null ? null : prec.Posicion.Id,
          entregaId: prec.Entrega.Id,
          monedaId: prec.Moneda.Id,
          productoId: prec.Producto.Id,
          fechaEdited: null,
          mercado: prec.Mercado ? prec.Mercado.Mercado : '-',
        });
      } else {
        this.precios.push({
          id: prec.Id,
          fecha: parseDate(prec.Fecha),
          // para la fecha de creacion y publicacion se usa el mismo campo: FechaPublicacion
          fechaCreacion: parseDate(prec.FechaPublicacion),
          producto: prec.Producto.Producto,
          precio: prec.Precio,
          moneda: prec.Moneda.Simbolo,
          varianza: prec.Varianza,
          responsable: prec.UsuarioCreador.UserFullName,
          checked: false,
          // precio anterior cargado en esta posicion y producto, se usa para calcular la varianza en caso de cambio
          precioAnterior: parseFloat(prec.Precio) - (parseFloat(prec.Varianza)),
          // precio original cargado antes de ser este editado, se usa para verificar si hubo ediciones de precio
          precioOriginal: prec.Precio,
          productoId: prec.Producto.Id,
          monedaId: prec.Moneda.Id,
          fechaEdited: null,
          mercado: prec.Mercado ? prec.Mercado.Mercado : '-',
        });
      }
    });
  }

  getCellValue(index, col) {
    switch (col) {
      case 'fecha de cotización':
      case 'fecha':
        if (this.isPizarraValidation) {
          if (this.precios[index].fechaEdited) {
            return moment(this.precios[index].fechaEdited).format('DD/MM/YY');
          } else {
            return moment(this.precios[index].fecha).format('DD/MM/YY');
          }
        } else {
          return moment(this.precios[index].fecha).format('DD/MM/YY HH:mm') + 'hs';
        }
      case 'fecha de creación':
        return moment(this.precios[index].fechaCreacion).format('DD/MM/YY HH:mm') + 'hs';
      case 'negocio':
        return this.precios[index].negocio;
      case 'entrega':
        return this.precios[index].entrega;
      case 'moneda':
        return this.precios[index].moneda;
      case 'producto':
        return this.precios[index].producto;
      case 'precio':
        return this.pricePipe.transform(this.precios[index].precio, 'clamp');
      case 'varianza':
        return this.pricePipe.transform(this.precios[index].varianza, 'clamp');
      case 'responsable':
        return this.precios[index].responsable;
      case 'mercado':
        return this.precios[index].mercado;
    }
  }

  onValidateChange(index, e) {
    this.precios[index].checked = e.checked;
  }

  onDeleteToggle(index) {
    const idToDelete = this.precios[index].id;
    if (!this.isPizarraValidation) {
      this.dialogsService.confirm(
        '¿ESTÁ SEGURO QUE DESEA RECHAZAR ESTE PRECIO?',
        this.precios[index].producto.toUpperCase() + ' ' +
        this.precios[index].entrega.toUpperCase() + ' ' +
        this.precios[index].moneda + ' ' +
        this.pricePipe.transform(this.precios[index].precio),
        'RECHAZAR',
        'CANCELAR')
        .subscribe(x => {
          if (x) {
            this.spinnerService.setShowFlag(true);
            this.preciosService.rechazarPrecio(idToDelete)
              .subscribe(res => {
                if (res) {
                  this.precios = this.precios.filter(y => y.id !== idToDelete);
                  this.spinnerService.setShowFlag(false);
                }
              }, (err) => {
                this.spinnerService.setShowFlag(false);
              });
          }
        });
    } else {
      this.dialogsService.confirm(
        '¿ESTÁ SEGURO QUE DESEA RECHAZAR ESTE PRECIO DE PIZARRA?',
        this.precios[index].producto.toUpperCase() + ' ' +
        this.precios[index].moneda + ' ' +
        this.pricePipe.transform(this.precios[index].precio),
        'RECHAZAR',
        'CANCELAR')
        .subscribe(x => {
          if (x) {
            this.spinnerService.setShowFlag(true);
            this.preciosService.rechazarPrecioPizarra(idToDelete)
              .subscribe(res => {
                if (res) {
                  this.precios = this.precios.filter(y => y.id !== idToDelete);
                  this.spinnerService.setShowFlag(false);
                }
              }, (err) => {
                this.spinnerService.setShowFlag(false);
              });
          }
        });
    }
  }

  onEditNumber(index) {
    const allowZero = !this.isPizarraValidation;
    this.dialogsService.showEditNumberDialog('EDITAR PRECIO', this.precios[index].precio, allowZero, false, 'Precio')
      .subscribe(res => {
        if (res || res === 0) {
          this.precios[index].precio = res;
          if (!this.isPizarraValidation) {
            this.precios[index].varianza = this.precios[index].precio - this.precios[index].precioAnterior;
          }
          this.precios[index].checked = true;
        }
      });
  }

  onEditMoneda(index) {
    const allowZero = !this.isPizarraValidation;
    this.dialogsService.showDropdownDialog('EDITAR MONEDA', this.precios[index].monedaId, this.monedaOptions)
      .subscribe(res => {
        if (res) {
          this.precios[index].monedaId = res;
          this.precios[index].moneda = this.monedaOptions.find(x => x.ID === res).Simbolo;
          this.precios[index].checked = true;
        }
      });
  }

  getvalueTooltip(index, col) {
    if (col === 'precio') {
      if (this.precios[index].precio !== this.precios[index].precioOriginal) {
        return 'Editado. Precio Original: ' + this.pricePipe.transform(this.precios[index].precioOriginal, 'clamp');
      }
    } else if (col === 'fecha de cotización') {
      if (this.precios[index].fechaEdited) {
        return 'Editada. Fecha original: ' + moment(this.precios[index].fecha).format('DD/MM/YY') + 'hs';
      }
    }
    return '';
  }

  onSubmit() {
    const pricesValidated = [];
    this.precios.forEach(val => {
      if (val.checked) {
        pricesValidated.push(val);
      }
    });
    if (pricesValidated.length) {
      this.dialogsService.confirm('¿Está seguro que desea validar estos precios?', null, 'Si, Aceptar', 'No, Cancelar')
        .subscribe(x => {
          if (x) {
            let pricesToSend;
            if (this.isPizarraValidation) {
              pricesToSend = pricesValidated.map(pr => ({
                Id: pr.id,
                Moneda: {
                  Id: pr.monedaId
                },
                Producto: {
                  Id: pr.productoId
                },
                Precio: pr.precio,
                Fecha: pr.fechaEdited ? dateToUnixTime(moment(pr.fechaEdited).toDate()) : dateToUnixTime(moment(pr.fecha).toDate())
              }));

              this.spinnerService.setShowFlag(true);

              this.preciosService.publicarPreciosPizarra(pricesToSend)
                .subscribe(res => {
                  this.spinnerService.setShowFlag(false);
                  if (res) {
                    this.router.navigateByUrl('/' + PATH_PIZARRA);
                  }
                }, (err) => {
                  this.spinnerService.setShowFlag(false);
                });

            } else {
              pricesToSend = pricesValidated.map(pr => ({
                Id: pr.id,
                MonedaId: pr.monedaId,
                ProductoId: pr.productoId,
                PosicionId: pr.posicionId,
                Precio: pr.precio,
                EntregaId: pr.entregaId
              }));

              this.spinnerService.setShowFlag(true);

              this.preciosService.publicarPrecios(pricesToSend)
                .subscribe(res => {
                  this.spinnerService.setShowFlag(false);
                  if (res) {
                    this.router.navigateByUrl('/' + PATH_PRECIOS);
                  }
                }, (err) => {
                  this.spinnerService.setShowFlag(false);
                });
            }
          }
        });
    } else {
      this.snackBar.open('Es necesario seleccionar al menos un precio para validar', '', {
        duration: 2000,
      });
    }
  }

  getColumnName(col) {
    if (col) {
      const sliced = col.split(' ');
      if (col === 'accion') {
        return '';
      } else if (sliced.length === 1) {
        return col.charAt(0).toUpperCase() + col.slice(1);
      } else if (sliced.length > 1) {
        let str = '';
        sliced.forEach(x => {
          str = x === 'de' ? str + x + ' ' : str + x.charAt(0).toUpperCase() + x.slice(1) + ' ';
        });
        return str;
      }
    }
  }

  navigateBack() {
    let hasChanges = false;
    this.precios.forEach(val => {
      if (val.checked || val.precioOriginal !== val.precio) {
        hasChanges = true;
      }
    });
    if (hasChanges) {
      this.dialogsService.confirm(null,
        '¿Está seguro de salir sin validar estos precios?',
        'SÍ, ACEPTAR',
        'NO, CANCELAR')
        .subscribe(res => {
          if (res) {
            this.pageHeader.catchEnded();
          }
        });
    } else {
      this.pageHeader.catchEnded();    
    }
  }

  onEditFecha(e) {
    const fecha = moment(e).format('YYYY-MM-DD');

    // primero verificamos si se seleccionó la fecha original
    if (moment(e).format('YYYY-MM-DD') === moment(this.precios[this.editFechaIndex].fecha).format('YYYY-MM-DD')) {
      // en caso de ser asi, la fecha editada se elimina
      this.precios[this.editFechaIndex].fechaEdited = null;
      return;
    }

    // verificar que no se pase de HOY
    const endOfDay = moment().endOf('day').toDate();
    if (e > endOfDay) {
      this.precios[this.editFechaIndex].fechaEdited = moment(moment(endOfDay).format('YYYY-MM-DD'));
    } else {
      this.precios[this.editFechaIndex].fechaEdited = moment(moment(e).format('YYYY-MM-DD'));
    }
  }

  showDatePicker(i) {
    this.editFechaIndex = i;
    this.datePicker.open();
  }

  getColumnNamesNoSpaces(col) {
    if (col.split(' ').length === 1) {
      return col;
    } else {
      return col.split(' ').join('-');
    }
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/validate-precio/validate-precio.component.ts